<template>
    <div class="body">
      <HeadDetailsGama :titleHead="'Retornar Listagem'"  :buttontemplate="true" :buttonbackCustom="true" style="font-family: 'Segoe UI';"></HeadDetailsGama>
         <div id="tablog" class="mt-4 ml-2">
          <div v-if="serachinput.length == ''">
              <div v-for="data in dataQma" :key="data.id">
                  <div class="d-flex flex-row mt-1 ml-2" style="font-family:'Segoe UI'">
                      <div class="linhaAling">
                          <div class="ballCrzy">
                              <div class="textNum">{{data.dia}}</div>
                              <div class="textNum">{{data.mes}}</div>
                          </div>
                          <div class="linhaSolid"></div>
                      </div>
                      <div class ="ml-3 mt-3 input">
                          <div class="squareCrzy">
                              <div class="Textneg"> {{data.codigoQMA}} | Revisão {{data.revisao}}</div>

                              <div class="Textneg2" :style="{'color': data.colorAcao}"> {{data.acao}} </div>

                              <div class="Textneg2">
                                  <div class="description-log">
                                     <i class="far fa-clock" style="scale: 1.25"></i>{{data.dataAcao}}
                                  </div>
                                  <div class="border">
                                  </div>
                                  <div class="description-log">
                                      <i class="fas fa-user-circle" style="scale: 1.25" ></i>{{data.usuarioAcao}}
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              </div>
              <div v-else>
                  <div v-for="data in dataQma" :key="data.id">
                      <div class="d-flex flex-row mt-1 ml-2" style="font-family:'Segoe UI'">
                          <div class="linhaAling">
                              <div class="ballCrzy">
                                  <div class="textNum">{{data.dia}}</div>
                                  <div class="textNum">{{data.mes}}</div>
                              </div>
                              <div class="linhaSolid"></div>
                          </div>
                          <div class ="ml-3 mt-3 input">
                              <div class="squareCrzy">
                                  <div class="Textneg"> {{data.codigoAPR}} | Revisão {{data.revisao}}</div>

                                  <div class="Textneg2" :style="{'color': data.colorAcao}"> {{data.acao}} </div>

                                  <div class="Textneg2">
                                      <div class="description-log">
                                          <i class="fas fa-user-circle" style="scale: 1.25" ></i>{{data.dataAcao}}
                                      </div>
                                      <div class="border">
                                      </div>
                                      <div class="description-log">
                                          <i class="far fa-clock" style="scale: 1.25"></i>{{data.usuarioAcao}}
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </template>

<script>

import ActionsForm from '@/shared/mixins/actionsForm'
import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
// import aprLogTemplate from '@/shared/http/repositories/business/aprLogTemplate'
import { loading } from '@/shared/utils/UIHelper'
import inqueryQmaRepository from '@/shared/http/repositories/business/qmaInquery.js'

export default {
  name: 'logQma',
  mixins: [ActionsForm],
  components: {HeadDetailsGama, inqueryQmaRepository},
  data () {
    return {
      serachinput: '',
      dataQma: [],
      idQma: null
    }
  },

  props: ['qma', 'propQma'],

  watch: {
  },

  mounted () {
  },
  methods: {
    onLoad () {
      const params = new URLSearchParams(window.location.search)
      params.forEach((value) => {
        this.idQma = value
      })
      loading.push()
      inqueryQmaRepository.GetLogQma(this.idQma)
        .then((Response) => {
          this.dataQma = Response.data.data
          loading.pop()
        })
        .catch(() => {
          loading.pop()
        })
    }
  }
}

</script>

    <style scoped>
  .body{
      width: 100%;
  }
  .input{
      width: 100%;
  }
  .form-control {
      display: block;
      width: 50%;
      height: calc(1.5em + 0.75rem + 2px);
      font-size: 0.875rem;
      font-weight: 400;
      line-height: 1.5;
      color: #495057;
      background-color: #fff;
      background-clip: padding-box;
      border: 1px solid #ced4da;
      border-radius: 5px;
  }
  #greenChange {
      color: #008148;
  }

  .ballCrzy {
      width: 50px;
      height: 50px;
      border-radius:50%;
      border: 3px solid;
      font-size: 16px;
  }

  .ballCrzyDone {
      display: flex;
      justify-content: center;
      padding-top: 13px;
      font-size: 20px;
  }

  .squareCrzy {
      width: 60%;
      height: 62%;
      background: rgb(243, 241, 241);
      border-radius:1px 15px 15px;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      padding: 1rem 1rem 1rem 2rem;
      font-family: 'Segoe UI';
      display: flex;
      justify-content: space-between;
  }

  .textNum{
      font-weight: bold;
      display: flex;
      justify-content: center;
      align-items: center;
  }

  .Textneg2 {
      font-size: 12px;
      color:rgb(146, 149, 146);
      font-family:'Segoe UI';
      font-weight: bold;
      display: flex;
      column-gap: 1rem;
  }

  .Textneg {
      font-weight: bold;
      font-size: 14px;
      color:#008148;
  }

  .linhaSolid {
      height: 125px;
      border-left: 2px solid;
  }

  .icon-adjustment {
      display: flex;
      align-items: baseline;
      border-radius: 5px;
      gap: 0.5rem;
      position: relative;
      width: 20rem;
      border-radius: 5px;
  }

  .form-control {
      display: block;
      width: 100%;
      height: calc(1.5em + 0.75rem + 2px);
      padding: 0.375rem 0.75rem;
      font-size: 0.875rem;
      font-weight: 400;
      line-height: 1.5;
      color: #495057;
      background-color: #fff;
      background-clip: padding-box;
      border: 1px solid #ced4da;
      border-radius: 5px;
      padding-left: 30px;
      }
  .linhaAling{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 3px;
      color: #008148;
  }

  #tablog{
      width: 100%;
  }

  .description-log {
      display: flex;
      gap: 1rem;
      font-family:'Segoe UI';
      align-items: center;
  }
  .input-search{
      width: 100%;
      display: flex;
      position: relative;
      gap: 1rem;
  }

  .icon-search{
      position: absolute;
      left: 10px;
      top: 10px;
      font-size: 14px;
  }
  .icone-search{
      position: absolute;
      left: 10px;
      top: 10px;
      font-size: 14px;
  }
  .search-container{
      position: relative;
  }

  </style>



// WEBPACK FOOTER //
// src/views/private/qma/inqueryQma/components/details/logQma/logQma.vue